import { render, staticRenderFns } from "./competition-card.vue?vue&type=template&id=1f09aaa2&scoped=true&"
import script from "./competition-card.vue?vue&type=script&lang=ts&"
export * from "./competition-card.vue?vue&type=script&lang=ts&"
import style0 from "./competition-card.vue?vue&type=style&index=0&id=1f09aaa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f09aaa2",
  null
  
)

export default component.exports